import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Popup, Icon, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import * as common from 'libs/commonFunc';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareMailItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { target, selectDeclareTargetNo, handleSelectDeclare } = this.props;
    const {
      declareNo,
      // isNis,
      declareFlag,
      subject,
      declareEpoch,
      extraInfo
    } = target.toJS();

    return (
      <Segment
        vertical
        className={cx('targetItem-wrapper mail', {
          selected: selectDeclareTargetNo === declareNo
        })}
        onClick={e => {
          e.stopPropagation();
          handleSelectDeclare(declareNo);
        }}
      >
        <Grid columns="equal" stackable>
          <Grid.Row textAlign="center">
            <Grid.Column className={cx('cell-label')}>
              {/* {isNis === 1 && <div className="nis-icon">{'국'}</div>} */}
              <div className={cx('cell-text', { external: declareFlag === 2 })}>
                {declareFlag === 2 ? '외부' : '훈련'}
              </div>
            </Grid.Column>
            <Grid.Column className={cx('cell-mail-title')} textAlign="left" title={subject}>
              <div className={cx('cell-text', 'ellipsis')}>{subject}</div>
            </Grid.Column>

            <Grid.Column className={cx('cell-targetInfo')} textAlign="left">
              {/* 대상자 정보 */}
              <Popup
                trigger={
                  <div className={cx('targetInfo-area', 'ellipsis')}>
                    <span className={cx('targetName')}>{extraInfo.declareName}</span>
                    <span className={cx('targetEmail ellipsis')}>{extraInfo.declareEmail ? `(${extraInfo.declareEmail})` : '-'}</span>
                  </div>
                }
                content={
                  <div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetItem_1', defaultMessage: '대상자 번호' }))}
                      </div>
                      <div className={cx('bold')}>{declareNo}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_21', defaultMessage: '이름' }))}
                      </div>
                      <div className={cx('bold')}>{extraInfo.declareName ? extraInfo.declareName : '-'}</div>
                    </div>
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetDetail_22', defaultMessage: '이메일' }))}
                      </div>
                      <div className={cx('bold')}>{extraInfo.declareEmail ? extraInfo.declareEmail : '-'}</div>
                    </div>
                  </div>
                }
                size="mini"
              />
            </Grid.Column>

            <Grid.Column className={cx('cell-epoch')}>
              <div className={cx('cell-text')}>{common.timeFormatFromUTCEpoch(declareEpoch)}</div>
            </Grid.Column>

            {/* <Grid.Column className={cx('cell-company')}>
              <Popup
                trigger={
                  <div className={cx('target-division', 'ellipsis')}>{extraInfo.declareDivision ? extraInfo.declareDivision : '-'}</div>
                }
                content={
                  <div>
                    <span>{defineMessages(formatMessage({ id: 'TargetItem_3', defaultMessage: '소속' })) + ' '}</span>
                    <span className={cx('bold')}>{extraInfo.declareDivision ? extraInfo.declareDivision : '-'}</span>
                  </div>
                }
                size="mini"
              />
              <Popup
                trigger={
                  <div className={cx('target-position', 'ellipsis')}>{targetPosition ? targetPosition : '-'}</div>
                }
                content={
                  <div>
                    <span>{defineMessages(formatMessage({ id: 'TargetItem_4', defaultMessage: '직급' })) + ' '}</span>
                    <span className={cx('bold')}>{targetPosition ? targetPosition : '-'}</span>
                  </div>
                }
                size="mini"
              />
            </Grid.Column> */}
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default injectIntl(DeclareMailItem);



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareMailItem.js